import { Form } from '../../classes/Form';

export default {
    namespaced: true,

    state: {
        edit: false,
        addresses: [],
        addressModal: false,
        address: null,
        orders: [],
        returnOrder: false,
        returnReasons: [
            { value: 'size', label: 'Не подошёл размер' },
            { value: 'style', label: 'Не понравился стиль' },
            { value: 'defekt', label: 'Обнаружен дефект' },
            { value: 'other', label: 'Другая причина' }
        ],

        returnProducts: [],
        paymentServices: [],
        returnOrderForm: new Form({
            order_id: null,
            refund_type: 'post',
            receiver: '',
            email: '',
            region: {
                id: '',
                name: '',
                type_short: ''
            },
            city: {
                id: '',
                name: '',
                type_short: ''
            },
            district: {
                id: '',
                name: '',
                type_short: ''
            },
            street: {
                id: '',
                name: '',
                type_short: ''
            },
            house: '',
            zip: '',
            flat: '',
            account_owner: '',
            bik: '',
            bank_inn: '',
            bank_name: '',
            correlation_account: '',
            payment_account: '',
            personal_account: '',
            card_number: '',
            products: [],
            check: true
        })
    },

    getters: {
        getAddressById: (state) => (id) => {
            return state.addresses.find(address => address.id === id);
        },

        editMode (state) {
            return state.edit !== false;
        },

        editable: (state) => (section) => {
            return state.edit === section;
        },
        findReturnIndex: (state) => (orderId, itemId) => {

            return state.returnProducts.findIndex(item => {
                return item.orderId === orderId && item.itemId === itemId;
            });
        },

        toReturn: (state, getters) => (orderId, itemId) => {

            return getters.findReturnIndex(orderId, itemId) !== -1;
        },

        otherReason: (state) => (orderId, itemId) => {

            let product = state.returnProducts.find(item => {
                return item.orderId === orderId && item.itemId === itemId;
            });

            return product && product.reasonKey === 'other';
        },
    },

    mutations: {
        setAddresses (state, addresses) {
            state.addresses = addresses;
        },

        pushAddress (state, address) {
            // just in case
            delete address.deliveries;

            let addresses = state.addresses;

            let addressIndex = addresses.map(item => item.id).indexOf(address.id);

            if (addressIndex !== -1) {
                Vue.set(state.addresses, addressIndex, address);
            } else {
                addresses.push(address);

                Vue.set(state, 'addresses', addresses);
            }
        },

        deleteAddress (state, index) {
            state.addresses.splice(index, 1);
        },

        editSection (state, section) {
            state.edit = section;
        },

        cancelEditing (state) {
            state.edit = false;
        },

        setOrders (state, orders) {
            Vue.set(state, 'orders', orders);
        },

        setPaymentServices (state, services) {
            Vue.set(state, 'paymentServices', services);
        },

        returnOrder (state, value) {
            state.returnOrder = value;
        },

        setReturnOrderFormValue (state, { key, value }) {
            state.returnOrderForm.errors.clear(key);

            Vue.set(state.returnOrderForm, key, value);
        },

        setAddressFormValue (state, { key, value }) {
            state.address.errors.clear(key);

            Vue.set(state.address, key, value);
        },

        showAddressForm (state, id) {
            state.addressModal = id ? id : 0;
        },

        hideAddressForm (state) {
            state.addressModal = false;
        },

        clearAddress (state) {
            state.address = null;
        }
    },

    actions: {

        toggleReturnProduct({ state, getters }, { orderId, itemId }) {
            let index = getters.findReturnIndex(orderId, itemId);

            if (index === -1) {
                state.returnProducts.push({
                    orderId: orderId,
                    itemId: itemId,
                    reasonKey: state.returnReasons[0].value,
                    reason: state.returnReasons[0].label
                });

            } else {
                state.returnProducts.splice(index, 1);
            }
        },

        setReason({ state, getters }, { event, orderId, itemId }) {
            let index = getters.findReturnIndex(orderId, itemId);

            Vue.set(state.returnProducts[index], 'reasonKey', event);

            let reason = state.returnReasons.find(obj => {
                return obj.value === event
            })

            Vue.set(state.returnProducts[index], 'reason', event !== 'other' ? reason.label : '');
        },

        setOtherReasonValue({ state, getters }, { event, orderId, itemId }) {
            let index = getters.findReturnIndex(orderId, itemId);

            Vue.set(state.returnProducts[index], 'reason', event);
        },

        postReturnOrder({ state, commit }) {
            state.returnOrderForm.products = state.returnProducts.filter(item => item.orderId === state.returnOrder);
            state.returnOrderForm.order_id = state.returnOrder;

            state.returnOrderForm
                .post('/account/return-applications')
                .then(response => {
                    if (response.status === 'success') {
                        if (response.redirectUrl) {
                            window.location.href = response.redirectUrl;
                        } else {
                            alert('Заявление на возврат успешно сформировано и отправлено на указанный при оформлении email');
                        }
                    } else {
                        alert('При формировании заявления произошла ошибка. Пожалуйста, повторите попытку позднее или обратитесь за помощью к администратору');
                    }
                })
                .catch(error => {
                    alert('При формировании заявления произошла ошибка. Пожалуйста, повторите попытку позднее или обратитесь за помощью к администратору');
                })
        },

        editAddress ({ state, getters }, addressId) {
            let address = getters['getAddressById'](addressId);

            if (address) {
                state.address = new Form(address.form);
            }
        },

        newAddress ({ state, rootState }) {
            let data = {
                region: {
                    id: '',
                    name: '',
                    type_short: ''
                },
                city: {
                    id: '',
                    name: '',
                    type_short: ''
                },
                district: {
                    id: '',
                    name: '',
                    type_short: ''
                },
                street: {
                    id: '',
                    name: '',
                    type_short: ''
                },
                house: '',
                zip: '',
                flat: '',
                with_delivery: true,
            };

            let location = rootState.geo.location;

            if (location) {
                data.region = location.region;
                data.city = location.city;
                data.district = location.district;
            }

            state.address = new Form(data);
        },

        addAddress ({ state, getters, commit, dispatch }) {
            state.address.post(state.modal ? '/account/addresses' : '/addresses')
                .then(response => {
                    if (response.status === 'success') {
                        if (response.data.deliveries) {
                            commit('delivery/addDeliveries', response.data.deliveries, { root: true });
                        }

                        commit('pushAddress', response.data);
                        dispatch('cart/setAddress', response.data.id, { root: true });

                        commit('hideAddressForm');
                    }
                });
        },

        updateAddress ({ state, commit }) {
            state.address.put('/account/addresses/' + state.addressModal)
                .then(response => {
                    if (response.status === 'success') {
                        commit('pushAddress', response.data);

                        commit('hideAddressForm');
                    }
                });
        }
    }
}
